import { InertiaLinkProps, Link } from "@inertiajs/react";
import { cn } from "@/lib/utils";

export function TableCellLink({ className, ...props }: InertiaLinkProps) {
  return (
    <Link
      className={cn("absolute inset-0 outline-none", className)}
      data-row-link={true}
      {...props}
    ></Link>
  );
}
